import _extends from "@babel/runtime/helpers/esm/extends";
import { useSuperIntl } from "./_";
import { ModalForm, ProFormText, ProFormTextArea } from '@ant-design/pro-components';
import React from 'react';
export var QuickModifier = function QuickModifier(properties) {
  var intl = useSuperIntl();
  return /*#__PURE__*/React.createElement(ModalForm, _extends({
    width: 604,
    modalProps: {
      centered: true
    },
    layout: "horizontal"
  }, properties), /*#__PURE__*/React.createElement(ProFormText, {
    name: "name",
    label: intl.formatMessage({
      id: 'Name'
    }),
    rules: [{
      required: true
    }]
  }), /*#__PURE__*/React.createElement(ProFormTextArea, {
    name: "description",
    label: intl.formatMessage({
      id: 'Description'
    }),
    formItemProps: {
      style: {
        marginBottom: 0
      }
    }
  }));
};